import { useQuery } from '@tanstack/react-query';
import { Text } from '@components/base/display';
import { Skeleton } from '@components/base/feedback';
import { Card, VStack, Grid } from '@components/base/layout';
import { useAdminAuthStore } from '../auth/store';
import { modulesService } from '../api/modulesService';
import { tenantsService } from '../api/tenantsService';
import { erpRegistriesService } from '../api/erpRegistriesService';

export function DashboardPage() {
  const user = useAdminAuthStore((state) => state.user);

  const { data: modulesData, isLoading: isLoadingModules } = useQuery({
    queryKey: ['admin', 'modules'],
    queryFn: () => modulesService.list(),
  });

  const { data: tenantsData, isLoading: isLoadingTenants } = useQuery({
    queryKey: ['admin', 'tenants'],
    queryFn: () => tenantsService.list(),
  });

  const { data: registriesData, isLoading: isLoadingRegistries } = useQuery({
    queryKey: ['admin', 'erp', 'registries'],
    queryFn: () => erpRegistriesService.list(),
  });

  const modulesCount = modulesData?.data.length ?? 0;
  const tenantsCount = tenantsData?.data.length ?? 0;
  const registriesCount = registriesData?.data.length ?? 0;
  const usersCount = tenantsData?.data.reduce((sum, t) => sum + t.user_count, 0) ?? 0;

  return (
    <VStack gap={6}>
      <VStack gap={1}>
        <Text as="h1" size="2xl" weight="bold">
          Dashboard
        </Text>
        <Text size="base" color="muted">
          Welcome back, {user?.name ?? 'Admin'}
        </Text>
      </VStack>

      <Grid columns={{ base: 1, sm: 2, lg: 4 }} gap={4}>
        <Grid.Item>
          <Card variant="outlined" padding="md">
            <Card.Content>
              <VStack gap={1}>
                <Text size="sm" color="muted">Modules</Text>
                {isLoadingModules ? (
                  <Skeleton variant="text" width="3rem" height="2rem" />
                ) : (
                  <Text size="2xl" weight="bold">{modulesCount}</Text>
                )}
              </VStack>
            </Card.Content>
          </Card>
        </Grid.Item>

        <Grid.Item>
          <Card variant="outlined" padding="md">
            <Card.Content>
              <VStack gap={1}>
                <Text size="sm" color="muted">Tenants</Text>
                {isLoadingTenants ? (
                  <Skeleton variant="text" width="3rem" height="2rem" />
                ) : (
                  <Text size="2xl" weight="bold">{tenantsCount}</Text>
                )}
              </VStack>
            </Card.Content>
          </Card>
        </Grid.Item>

        <Grid.Item>
          <Card variant="outlined" padding="md">
            <Card.Content>
              <VStack gap={1}>
                <Text size="sm" color="muted">Registries</Text>
                {isLoadingRegistries ? (
                  <Skeleton variant="text" width="3rem" height="2rem" />
                ) : (
                  <Text size="2xl" weight="bold">{registriesCount}</Text>
                )}
              </VStack>
            </Card.Content>
          </Card>
        </Grid.Item>

        <Grid.Item>
          <Card variant="outlined" padding="md">
            <Card.Content>
              <VStack gap={1}>
                <Text size="sm" color="muted">Users</Text>
                {isLoadingTenants ? (
                  <Skeleton variant="text" width="3rem" height="2rem" />
                ) : (
                  <Text size="2xl" weight="bold">{usersCount}</Text>
                )}
              </VStack>
            </Card.Content>
          </Card>
        </Grid.Item>
      </Grid>
    </VStack>
  );
}
